import React, { useEffect, useRef } from 'react'
import { useSnapshot } from 'valtio'
import { openOptionsMenu } from '../../globalState'
import {
  closeNavAuthDropdown,
  restoreUtopiaAuthSession,
  toggleNavAuthDropdown,
  utopiaAuthState,
  utopiaAuthUiState,
} from './utopiaAuthState'
import UtopiaAuthForm from './UtopiaAuthForm'
import styles from './utopiaLanding.module.css'

type Props = {
  onOptionsClick?: () => void
  onPlayClick?: () => void
}

export default function UtopiaNavAuthDropdown ({ onOptionsClick, onPlayClick }: Props) {
  const { user } = useSnapshot(utopiaAuthState)
  const { navDropdownOpen } = useSnapshot(utopiaAuthUiState)
  const wrapRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    void restoreUtopiaAuthSession()
  }, [])

  useEffect(() => {
    if (!navDropdownOpen) return
    const onPointerDown = (e: PointerEvent) => {
      if (!wrapRef.current?.contains(e.target as Node)) {
        closeNavAuthDropdown()
      }
    }
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeNavAuthDropdown()
    }
    document.addEventListener('pointerdown', onPointerDown)
    document.addEventListener('keydown', onKeyDown)
    return () => {
      document.removeEventListener('pointerdown', onPointerDown)
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [navDropdownOpen])

  const label = user ? user.gameUsername : 'Connexion'

  const openOptions = () => {
    closeNavAuthDropdown()
    if (onOptionsClick) onOptionsClick()
    else openOptionsMenu('main')
  }

  return (
    <div className={styles.navAuthCluster} ref={wrapRef}>
      <div className={styles.navAuthWrap}>
        <button
          type="button"
          className={`${styles.navAuthLoginBtn} ${navDropdownOpen ? styles.navAuthLoginBtnOpen : ''}`}
          aria-expanded={navDropdownOpen}
          aria-haspopup="true"
          onClick={() => toggleNavAuthDropdown()}
          title={user ? user.gameUsername : undefined}
        >
          <span className={user ? styles.navAuthPseudo : undefined}>{label}</span>
          <span className={styles.navAuthChevron} aria-hidden>▾</span>
        </button>

        {navDropdownOpen && (
          <>
            <button
              type="button"
              className={styles.navAuthDropdownBackdrop}
              aria-label="Fermer"
              tabIndex={-1}
              onClick={closeNavAuthDropdown}
            />
            <div
              className={styles.navAuthDropdown}
              role="dialog"
              aria-label={user ? 'Compte Utopie' : 'Connexion Utopie'}
            >
              <div
                className={styles.navAuthDropdownBody}
                onWheel={e => e.stopPropagation()}
              >
                <UtopiaAuthForm
                  idPrefix="utopia-nav-auth"
                  onClose={closeNavAuthDropdown}
                  onSuccess={closeNavAuthDropdown}
                  onOptionsClick={user ? openOptions : undefined}
                  onPlayClick={user ? () => {
                    closeNavAuthDropdown()
                    onPlayClick?.()
                  } : undefined}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
